export default "__VITE_ASSET__DHYIkWvU__ 194w";